import { FeatureKey } from "../global-types/global-types";

export const featureKeyMapping: Record<string, FeatureKey> = {
  analytics_config: "analytics",
  dte_config: "dte",
  crm_config: "crm",
  pms_config: "pms",
  campaign_config: "campaigns",
  playground_config: "playground",
  communication_config: "communication",
  user_management_config: "user_management",
  billing_config: "billing",
  settings_config: "settings",
  configurability_config: "configurability",
  ticket_config: "ticket_management",
  alert_config: "alerts",
  kam_config: "kam",
  user_manual_config: "user_manual",
  vf_copilot_config: "vf_copilot",
};
